<template>
  <div class="rich-cell" v-if="content.length!=0">
    <div :key="i" v-for="(v,i) in content">
      <bui-richcell-text
        v-if="v.type=='text' && v.value"
        @textclick="click($event,v)"
        :text-value="v.value"
        :text-style="v.style"
        :has-text-margin="hasTextMargin"
        :text-theme="v.theme"
      ></bui-richcell-text>
    </div>
  </div>
</template>

<style scoped>
.rich-cell {
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>

<script>
import ouiRichCellText from '@/components/richCellText.vue';

export default {
  components: {
    'bui-richcell-text': ouiRichCellText,
  },
  props: {
    contentArr: {
      type: Array,
      default: () => [],
    },
    keywordsArr: {
      type: Array,
      default: () => [],
    },
    hasTextMargin: {
      type: Boolean,
      default: false,
    },
    linkTheme: {
      type: String,
      default: 'blue',
    },
    textTheme: {
      type: String,
      default: 'gray',
    },
  },
  computed: {
    content() {
      const richTextConfig = [];
      this.contentArr.forEach((item) => {
        let clickIndex = -1;
        if (this.keywordsArr.findIndex) {
          clickIndex = this.keywordsArr.findIndex((keyword) => keyword === item);
        }
        if (item) {
          if (clickIndex !== -1) {
            item.split('').forEach((char) => {
              richTextConfig.push({
                type: 'text',
                value: char,
                theme: this.linkTheme,
                clickIndex,
              });
            });
          } else {
            item.split('').forEach((char) => {
              richTextConfig.push({
                type: 'text',
                value: char,
                theme: this.textTheme,
              });
            });
          }
        }
      });
      return richTextConfig;
    },
  },
  methods: {
    click(e, obj) {
      this.$emit('textclick', e, obj);
    },
  },
  data: () => ({}),
};
</script>
